<template>
  <div>
    <list
      ref="refBrandsList"
      sort-by="tipoMarcaId"
      refetch-records-name="marcas"
      key-field="TipoMarcaId"
      :actions="actions"
      :filters.sync="filters"
      :table-columns="tableColumns"
      :table-actions="tableActions"
      :refetch-records="fetchBrands"
      :sort-dir-desc="false"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'
import i18n from '@/libs/i18n'
import tiService from '@/services/informationTecnology.service'
import List from '@/components/List.vue'

export default {
  components: {
    List,
  },
  setup() {
    const { fetchBrands } = tiService()
    const refBrandsList = ref(null)
    const filters = ref([])
    const tableColumns = [
      {
        key: 'tipoMarcaId',
        label: i18n.t('AppTI.columns.id'),
        sortable: true,
        sortKey: 'TipoMarcaId',
      },
      {
        key: 'nombre',
        label: i18n.t('AppTI.columns.name'),
        sortable: false,
      },
      {
        label: i18n.t('Lists.Actions'),
        key: 'actions',
        sortable: false,
      },
    ]
    const tableActions = ref([
      {
        name: 'edit',
        label: i18n.t('Lists.Details'),
        aclAction: 'read',
        aclResource: 'MesaAyuda',
        routeName: 'apps-brands-details',
        params: ['tipoMarcaId'],
        icon: 'Edit2Icon',
      },
    ])
    const actions = ref([
      {
        label: i18n.t('AppTI.actions.newBrand'),
        aclAction: 'create',
        aclResource: 'MesaAyuda',
        routeName: 'apps-brands-add',
        icon: 'PlusCircleIcon',
      },
    ])

    return {
      refBrandsList,
      filters,
      tableColumns,
      tableActions,
      actions,
      fetchBrands,
    }
  },
}
</script>
